// pages/UpdateModulePage.tsx
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageListLayout from "../../../layouts/PageListLayout";
import ModuleForm from "../../../components/features/modules/ModuleForm";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import { Module } from "../../../types/features/Module";

export default function UpdateModulePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [module, setModule] = useState<Module | null>(null);

  // Récupérer les données du module depuis la navigation (state)
  useEffect(() => {
    const state = location.state as { module: Module };
    if (state?.module) {
      setModule(state.module);
    } else {
      // Si pas de state, rediriger vers la liste
      navigate("/admin/modules");
    }
  }, [location, navigate]);

  const handleSubmit = async (data: Partial<Module>) => {
    if (!module) return;
    
    setIsLoading(true);
    try {
      // Appel API pour mettre à jour le module
      console.log("Mise à jour du module:", { id: module.id, ...data });
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulation
      
      alertSuccess("Module mis à jour avec succès !");
      navigate("/admin/modules");
    } catch (error) {
      alertError("Erreur lors de la mise à jour du module");
    } finally {
      setIsLoading(false);
    }
  };

  if (!module) return null;

  return (
    <PageListLayout title="">
      <div className="px-6 py-5 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-bold text-[#031B4E] tracking-tight">
            Modifier le module
          </h1>
          <p className="text-sm text-slate-400 font-light mt-0.5">
            {module.name}
          </p>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto">
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <ModuleForm
            initialData={module}
            onSubmit={handleSubmit}
            onCancel={() => navigate("/admin/modules")}
            isLoading={isLoading}
            isEdit={true}
          />
        </div>
      </div>
    </PageListLayout>
  );
}